import type React from 'react';
import { classNames } from '@/lib/utils';
import type { ErrorDisplayProps } from './ErrorDisplay.types';

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  title,
  message,
  actionLabel,
  onAction,
  className = '',
}) => {
  return (
    <div className={classNames('flex flex-col items-center justify-center gap-6 p-8', className)} role="alert">
      <div className="flex flex-col items-center gap-4 text-center">
        <h2 className="text-xl font-semibold text-white">{title}</h2>
        <p className="text-sm text-gray-300">{message}</p>
      </div>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="px-6 py-3 bg-overlay-light text-white hover:bg-overlay-medium border border-overlay-dark rounded text-sm font-medium transition-all duration-200"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};
